module.exports = __webpack_public_path__ + "media/images/archive_black-db3fc6a99b053651cbcb0811e1b45158.svg";